<div class="card-container-grey padding-md border-radius-sm"
  [class.card-container-active]="active"
  [class.disabled]="disabled"
  [class.cursor-pointer]="selectable"
  nz-popover="" nzPopoverTitle="" [nzPopoverContent]="erasable ? 'Clic para remover' : ''"
  (click)="onEmitSelected()">
  <div class="mr-xs">
    <app-avatar-user [image]="imageProfile" [name]="name" [lastname]="lastName" [width]="45" [fontSize]="'15px'"></app-avatar-user>
  </div>
  <div class="content">
    <div class="text-regular-14 truncate">{{ name }}</div>
    <div class="text-info"><span *ngIf="birthday"> {{ birthday | getAge }} años</span></div>
  </div>
  <div class="card-container-icon-active" *ngIf="active">
    <img loading="lazy" src="./../../../assets/images/icons/icons8-checkmark-100.png" alt="">
  </div>
</div>
